import React, { FC } from 'react';

import { Chip } from '@material-ui/core';
import { useHistory } from 'react-router-dom';

import Button from 'Components-redesign/Button';
import { Heading } from 'Components-redesign/Typography/Heading';
import { Paragraph } from 'Components-redesign/Typography/Paragraph';
import { useI18n } from 'Hooks';
import { GetLatestReleases_superAdminViewer_latestReleases_items } from 'Scenes/Releases/api/__queries__';
import { ReleaseWrapper } from 'Scenes/Releases/styles';
import { Box } from 'styles/box';
import { formatDate } from 'utils/dates';

interface Props {
  features: GetLatestReleases_superAdminViewer_latestReleases_items[];
}

/** Component that lists all releases with type FEATURE */
const Features: FC<Props> = ({ features }) => {
  const { t } = useI18n();
  const history = useHistory();

  return (
    <>
      {features.map((feature) => (
        <ReleaseWrapper
          key={feature.id}
          padding="medium"
          display="flex"
          flexDirection="column"
          gap="xs">
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Paragraph level={5} color="var(--colorBlueGray800)">
              {t('Releases.UpdatedAt')}: {formatDate(feature.updatedAt, 'YYYY-MM-DD HH:mm')}
            </Paragraph>

            <Paragraph level={5} color="var(--colorBlueGray800)">
              {t('Releases.CreatedBy')}: {feature.createdBy}
            </Paragraph>
          </Box>

          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Heading level={2}>{t(feature.titleLang.en)}</Heading>
            <Button
              text={t('General.Edit')}
              width="120px"
              height="40px"
              styleType="Dark"
              handleClick={() => history.push(`/releases?id=${feature.id}&type=feature`)}
            />
          </Box>

          <Box display="flex" flexDirection="row" gap="xs" marginBottom="xs">
            {feature.productTags.map((tag) => (
              <Chip size="small" label={tag} />
            ))}
          </Box>

          <Paragraph level={4}>
            {t(feature.bodyLang.en)
              .split('\n')
              .map((line, index) => (
                <React.Fragment key={index}>
                  {line}
                  {index < t(feature.bodyLang.en).split('\n').length - 1 && <br />}
                </React.Fragment>
              ))}
          </Paragraph>

          <Box
            display="flex"
            flexDirection="row"
            gap="xs"
            padding="xs"
            style={{ backgroundColor: 'var(--colorBlueGray100)', borderRadius: '8px' }}>
            {feature.imageUrls.map((url) => (
              <img
                key={url}
                src={url}
                alt="Release"
                style={{ height: '100px', borderRadius: '8px' }}
              />
            ))}
          </Box>
        </ReleaseWrapper>
      ))}
    </>
  );
};

export default Features;
